var lottery = window.lotus.lottery;
export default lottery;
